import TribesFilters from './TribesFilters'

export default TribesFilters